// extracted by mini-css-extract-plugin
module.exports = {"forbidden":"noData_forbidden__YakDF"};